import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';

@Injectable()
export class AccountLookupService {
    constructor(private httpClient: HttpClient) { }

    public getUsers() {
        return this.httpClient.get<any>('https://jsonplaceholder.typicode.com/users')
      }
    
    
}